import { Link } from "react-router-dom";

const BreadcrumbChevron = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const buildLegacyBreadcrumbs = (motherMenu, activeMenu) => {
  const crumbs = [];

  if (motherMenu?.trim()) {
    crumbs.push({ label: motherMenu.trim() });
  }

  if (activeMenu?.trim()) {
    const parts = activeMenu
      .split(">")
      .map((part) => part.trim())
      .filter(Boolean);

    parts.forEach((part) => {
      crumbs.push({ label: part });
    });
  }

  return crumbs;
};

const PageTitle = ({
  breadcrumbs = [],
  pageTitle,
  title,
  subtitle,
  motherMenu,
  activeMenu,
  actions,
}) => {
  const resolvedTitle =
    pageTitle ||
    title ||
    (breadcrumbs.length ? breadcrumbs[breadcrumbs.length - 1]?.label : "") ||
    "";

  let resolvedBreadcrumbs = breadcrumbs;

  if (!resolvedBreadcrumbs.length && (motherMenu || activeMenu)) {
    resolvedBreadcrumbs = buildLegacyBreadcrumbs(motherMenu, activeMenu);
  }

  if (!resolvedBreadcrumbs.length && resolvedTitle) {
    resolvedBreadcrumbs = [{ label: resolvedTitle }];
  }

  const trail = resolvedBreadcrumbs.filter((item) => item.label !== "Home");

  return (
    <div className="qx-page-head">
      <div className="qx-page-head-left">
        <h2 className="qx-page-title">{resolvedTitle}</h2>
        {subtitle ? <p className="qx-page-subtitle">{subtitle}</p> : null}
      </div>

      <div className="qx-page-head-right">
        {actions ? <div className="qx-page-head-actions">{actions}</div> : null}
        <nav aria-label="breadcrumb">
          <ol className="qx-breadcrumb">
            {/* <li>
              <Link to="/dashboard" className="qx-breadcrumb-link">
                Home
                <BreadcrumbChevron />
              </Link>
            </li> */}
            {/* {trail.map((item, index) => {
              const isLast = index === trail.length - 1;
              return (
                <li
                  key={`${item.label}-${index}`}
                  className={isLast ? "qx-breadcrumb-current" : ""}
                >
                  {item.path && !isLast ? (
                    <Link
                      to={item.path}
                      state={item.state}
                      className="qx-breadcrumb-link"
                    >
                      {item.label}
                      <BreadcrumbChevron />
                    </Link>
                  ) : (
                    <span>{item.label}</span>
                  )}
                </li>
              );
            })} */}
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default PageTitle;
